import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55bf78cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-wrap" }
const _hoisted_2 = { class: "success-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-tip" }, "提交成功", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-description" }, "您补办申请已经提交，请耐心等待专员审批。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shipment-tip" }, [
  /*#__PURE__*/_createElementVNode("div", null, "确认收货规则说明： 订单发货后，客户收到货后应及时在订单页面点击“确认收货”。"),
  /*#__PURE__*/_createElementVNode("div", { class: "shipment-content" }, [
    /*#__PURE__*/_createElementVNode("div", null, "以下场景会自动确认收货："),
    /*#__PURE__*/_createElementVNode("div", null, "1、抓取到物流节点“已签收”则系统会自动确认收货 。"),
    /*#__PURE__*/_createElementVNode("div", null, "2、自发货起，超过7天会自动确认收货。")
  ])
], -1))

import AppHeader from '@/components/Header.vue'
import Success from '@/assets/nameplate-reissue/success.svg'
import { Icon, Button } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {
  NameplateReissueDetail,
  NameplateReissueList,
  NameplateReissueApply,
} from '@/store/nameplate-reissue'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'confirm-success',
  setup(__props) {

let $router = useRouter()
let $route = useRoute()
let $store = useStore()
function continueConfirmHandler() {
  $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueApply)
  $router.replace({
    name: 'nameplate-reissue-apply',
  })
}

function leftClickHandle() {
  $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueList)
  $router.go(-1)
}

function viewDetailHandler() {
  $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueDetail)
  $router.replace({
    name: 'nameplate-reissue-detail',
    query: {
      guid: $route.query.guid,
      ifFormConfirmSuccess: 'yes',
    },
  })
}
onMounted(() => {
  console.log('replace')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      isReturnLeftEvent: true,
      onLeftClick: leftClickHandle
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Icon), {
          name: _unref(Success),
          size: 60
        }, null, 8, ["name"]),
        _hoisted_3,
        _hoisted_4,
        _createVNode(_unref(Button), {
          color: "rgba(0, 195, 120, 1)",
          class: "continue-success-btn",
          onClick: continueConfirmHandler
        }, {
          default: _withCtx(() => [
            _createTextVNode("继续提交")
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          color: "rgba(0, 0, 0, 0.04)",
          style: _normalizeStyle({ color: 'rgba(0, 175, 108, 1) ' }),
          class: "view-btn",
          onClick: viewDetailHandler
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看申请详情")
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _hoisted_5
    ])
  ], 64))
}
}

})